/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Origin_Agent_ManagementInputs */



/**
* | output |
* | --- |
* | "Agent Management" |
*
* @param {Audit_Origin_Agent_ManagementInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_origin_agent_management = /** @type {((inputs?: Audit_Origin_Agent_ManagementInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Origin_Agent_ManagementInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Agentenverwaltung")
	return /** @type {LocalizedString} */ ("Agent Management")
});